import { render, staticRenderFns } from "./expensesreportcategory.vue?vue&type=template&id=5f0c769e"
import script from "./expensesreportcategory.vue?vue&type=script&lang=js"
export * from "./expensesreportcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports